import { render, staticRenderFns } from "./ticket-infos.vue?vue&type=template&id=4804ce38"
import script from "./ticket-infos.vue?vue&type=script&lang=js"
export * from "./ticket-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports